import { NotebookViewBody } from "./NotebookViewBody";
import { NotebookViewMain } from "./NotebookViewMain";
import { NotebookViewMainBody } from "./NotebookViewMainBody";
import { NotebookViewMainHeader } from "./NotebookViewMainHeader";
import { NotebookViewMainHeaderGroup } from "./NotebookViewMainHeaderGroup";
import { NotebookViewMainTabs } from "./NotebookViewMainTabs";
import { NotebookViewSidebar } from "./NotebookViewSidebar";
import { NotebookViewMasthead } from "./NotebookViewMasthead";

import "./NotebookView.css";

import type { ReactNode } from "react";

export interface NotebookViewProps {
  children?: ReactNode;
  isLoading?: boolean;
}

export interface NotebookViewStateAndHelpers {
  isActionsOpen: boolean;
  closeActions: () => void;
  resetTabScroll: () => void;
}

export function NotebookView({ children, isLoading }: NotebookViewProps) {
  return (
    <div className="NotebookView" data-loading={isLoading}>
      {children}
    </div>
  );
}

NotebookView.Body = NotebookViewBody;
NotebookView.Main = NotebookViewMain;
NotebookView.MainBody = NotebookViewMainBody;
NotebookView.MainHeader = NotebookViewMainHeader;
NotebookView.MainHeaderGroup = NotebookViewMainHeaderGroup;
NotebookView.MainTabs = NotebookViewMainTabs;
NotebookView.Masthead = NotebookViewMasthead;
NotebookView.Sidebar = NotebookViewSidebar;
